import { createSelector } from 'reselect';

import { LibraryCourseContainerStore } from './typings';

const libraryCourseContainerStoreSelector = (storeState: any): LibraryCourseContainerStore =>
    storeState.libraryCourseContainer;

export const getOpenedModule = createSelector(
    [libraryCourseContainerStoreSelector],
    (courseContainerStore: LibraryCourseContainerStore): number | null => courseContainerStore.openedModule
);

export const getExpandedLessonGroup = createSelector(
    [libraryCourseContainerStoreSelector],
    (courseContainerStore: LibraryCourseContainerStore): string | null => courseContainerStore.expandedLessonGroup
);

export const getOpenedCourseContainerSlug = createSelector(
    [libraryCourseContainerStoreSelector],
    (courseContainerStore: LibraryCourseContainerStore): string | null => courseContainerStore.openedCourseContainerSlug
);
